type WaitOptions = {
  // 「安定した」と判定するために必要な連続一致サンプル数
  stableSamples?: number;
  // サンプリング間隔（ミリ秒）
  intervalMs?: number;
  // 待機の上限（ミリ秒）。超えた場合はベストエフォートでそのまま続行する
  timeoutMs?: number;
};

// SVG の実寸とコンテンツの描画位置をまとめて 1 つの文字列にする。
// getBoundingClientRect を使うことで、ズーム変換が attribute / style のどちらで
// 適用されていても差分を検出できる（e2e の waitForCanvasStable と同じ考え方）。
function readGeometry(svg: SVGSVGElement): string {
  const content = svg.querySelector(':scope > g');
  // サブピクセルの揺れで収束しなくなるのを避けるため整数に丸める
  const rect = (content ?? svg).getBoundingClientRect();
  return [
    svg.getAttribute('width'),
    svg.getAttribute('height'),
    svg.getAttribute('viewBox'),
    Math.round(rect.x),
    Math.round(rect.y),
    Math.round(rect.width),
    Math.round(rect.height),
  ].join('|');
}

/**
 * SVG の実測ジオメトリが連続して変化しなくなるまで待つ.
 *
 * zoom-to-fit 直後のキャプチャで、ズーム変換やレイアウトが描画へ反映されきる前に
 * SVG をシリアライズしてしまう競合を避けるための安定待ち。
 * タイムアウトした場合は例外を投げず、ベストエフォートでそのまま続行する
 * （手動エクスポートは安定待ちなしで実行されており、それより悪くはならないため）。
 */
export async function waitForSVGGeometryStable(svg: SVGSVGElement, options: WaitOptions = {}): Promise<void> {
  const { stableSamples = 3, intervalMs = 50, timeoutMs = 3000 } = options;

  const deadline = Date.now() + timeoutMs;
  let previous: string | null = null;
  let stableCount = 0;

  while (Date.now() < deadline) {
    const current = readGeometry(svg);

    if (previous !== null && current === previous) {
      stableCount += 1;
      if (stableCount >= stableSamples) return;
    } else {
      stableCount = 0;
    }

    previous = current;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
}
